<template>
    <tr class="signif_p">
        <td>
            {{ variableTitle }}
        </td>
        <td align="right">
            {{ common.formatNumber(statistics.degreesOfFreedom, 0) }}
        </td>
        <td align="right">
            {{ common.formatNumber(statistics.waldChiSquare, 2) }}
        </td>
        <td align="right">
            {{
                common.formatNumberWithMinimum(
                    statistics.pValue,
                    4,
                    statistics.isPValueBelowMinimum
                )
            }}
        </td>
    </tr>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';

export default {
    props: ['variableTitle', 'statistics'],
    data: function () {
        var vm = this;
        return {
            common: common
        };
    },
    methods: {}
};
</script>

<style scoped>
</style>
